import { Rules } from '@/types';

const APPROVED_PASSWORD_SYMBOLS = ['!', '@', '#', '$', '%', '^', '&', '*', '\'', '(', ')', '{', '}', '.', '_', '-', '+', '`', '~', '=', '\\', '|', ';', ':', '\'', '"', '/', '?', '<', '>'];

export const formMixins = {
  rules: {
    namesOnlyLetters: (value: string, message: string): string | true => {
      const pattern = /^([\u0400-\u04FF]+$)|^([a-zA-Z]+$)/;
      return pattern.test(value) || message || 'must include only letters';
    },
    nameMin: (value: string, message: string, min: number = 2) => {
      return value.length >= min || message || `${value} must be more then ${min}`;
    },
    nameMax: (value: string, message: string, max: number = 30) => {
      return value.length <= max || message || `${value} must be less then ${max}`;
    },
    canBeAccess: (value: boolean, message: string) => {
      return !!value || message || 'Please agree with condition';
    },
    email: (value: string, messages: any) => {
      if (!value || !value.includes('@')) {
        return  messages.at || false;
      }
      const [ user, domain ] = value.split('@');
      // tslint:disable-next-line: max-line-length
      const userReg = /^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*$|^\"([\001-\010\013\014\016-\037!#-\[\]-\177]|\\[\001-\011\013\014\016-\177])*\"$/gmi;
      if (!user.match(userReg)) {
        return messages.user || false;
      }
      const domainReg = /((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+)(?:[A-Z0-9-]{2,63})$/gmi;
      if (!domain.match(domainReg) || domain.indexOf('-') === domain.length - 1) {
        return  messages.domain || false;
      }
      return true;
    },
    required: (value: string, message: string) => !!value || message || 'This field is required!',
    phone: (value: string, message: string) => {
      const numbers: number = parseInt(value, 10);
      return (numbers.toString().length >= 12 && numbers.toString().length <= 14) || message
        || 'Phone must 12 - 14 numbers!';
    },
    emailOrPhone: (value: string, messages: object) => {
      if (!value) { return  (messages as any).required || 'This field is required!'; }
      const numbers: number = parseInt(value, 10);
      return value.charAt(0) === '+'
        ? (numbers.toString().length >= 12 && numbers.toString().length <= 14)
          || (messages as any).phone || 'Phone must 12 - 14 numbers!'
        : formMixins.rules.email(value, (messages as any).email);
    },
    password: (value: string, messages: any) => {
      if (!value) {
        return messages;
      }
      if (!/[(\W)|_]/g.test(value) && /\d/.test(value) && /[A-Za-z]/.test(value)) {
        return true;
      } else if (value.match(/[(\W)|_]/g) && (/\d/.test(value) || /[A-Za-z]/.test(value))) {
        const symbols = value.match(/[(\W)|_]/g) || [];
        const illegalSymbol = symbols.find((symbol) => !APPROVED_PASSWORD_SYMBOLS.includes(symbol));
        return illegalSymbol ? messages : true;
      } else {
        return messages;
      }
    },
    withoutCyrillic : (value: string, messages: any) => {
      return /[а-яА-ЯЁё]|[а-яА-Я]/.test(value) ? messages : true;
    },


  } as Rules,
};
